import { format, isSameYear } from 'date-fns'
import type { TicketNetwork } from './types'
import { lat, long } from '~/stores/geo'

export function getGeoFilter(mi = 40) {
	let curLat = lat.get() || '40.7128'
	let curLong = long.get() || '-74.0060'
	// console.log('latlong getGeoFilter', curLat, curLong)

	return `nearby(${curLat}, ${curLong}, ${mi}mi)`
}

// TODO: check this
export function formatDate(d: TicketNetwork.Result['date']) {
	try {
		const { datetime } = d
		const newDate = new Date(datetime)
		let sameYear = isSameYear(newDate, new Date())

		return newDate.toLocaleDateString('en-US', {
			...(!sameYear && { year: 'numeric' }),
			month: 'short',
			day: 'numeric',
		})
	} catch (error) {
		console.error(error)
		return d.date || ''
	}
}

export function normalizeDate(d: Date) {
	try {
		const formattedDate = format(d, 'EEEE MMMM do, yyyy')
		return formattedDate
	} catch (error) {
		return d.toISOString()
	}
}

const weekdays = [
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
]
const shortWeekdays = ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat']

export function getWeekday(num: number, short = false) {
	try {
		return short ? shortWeekdays[num - 1] : weekdays[num - 1]
	} catch (error) {
		console.error(error)
	}
}

export function eventShortName(event: TicketNetwork.Result) {
	try {
		const { performers, text } = event
		let homeTeam = performers.find((p) => p.role === 'Home Team')
		let awayTeam = performers.find((p) => p.role === 'Away Team')

		if (homeTeam && awayTeam) {
			return `${awayTeam.name} at ${homeTeam.name}`
		}

		return text?.name
	} catch (error) {
		return event?.text?.name
	}
}

export function slug(s: string) {
	try {
		const a =
			'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b =
			'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz--'
		const p = new RegExp(a.split('').join('|'), 'g')

		return s
			.toString()
			.toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text
	} catch (error) {
		return 'unknown-slug'
	}
}

export const generateLink = {
	event(name: string, id: number | string) {
		return `/events/${slug(name)}/${id}`
	},
	performer(name: string, id: number | string) {
		return `/performers/${slug(name)}-tickets/${id}`
	},
	venue(name: string, id: number | string) {
		return `/venues/${slug(name)}-tickets/${id}`
	},
}

export const clickOutside = (node) => {
	const handleClick = (event) => {
		if (!node.contains(event.target)) {
			node.dispatchEvent(new CustomEvent('outclick'))
		}
	}

	document.addEventListener('click', handleClick, true)

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true)
		},
	}
}

// const sentry = new Toucan({
//     dsn: 'YOUR_SENTRY_DSN',
//     request,
//     tracesSampleRate: 1.0,
//   });
